import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { globals } from '../globals';
import { TipoArquivo } from '../models/enum';

@Injectable({
  providedIn: 'root'
})
export class ArquivoService {

  constructor(private http: HttpClient) { }

  baixarArquivo(id, tipo: TipoArquivo) {
    return this.http.get(globals.apiUrl + '/api/Arquivo/BaixarArquivo',
      { params: new HttpParams().set('id', id).set('tipo', tipo.toString()), responseType: 'blob' });
  }
}
